
import { useIntl } from 'react-intl'
import { KTSVG, toAbsoluteUrl } from '../../../../../_dashboard/helpers'
import { useLang } from '../../../../../_dashboard/i18n/Metronici18n'
import { useListView } from '../core/ListViewProvider'
import {PaymentMethodListFilter} from './PaymentMethodListFilter'

const PaymentMethodListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const languages = [
    {
      lang: 'en',
      name: 'English',
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    {
      lang: 'zh',
      name: 'Mandarin',
      flag: toAbsoluteUrl('/media/flags/china.svg'),
    },
    {
      lang: 'es',
      name: 'Spanish',
      flag: toAbsoluteUrl('/media/flags/spain.svg'),
    },
    {
      lang: 'ja',
      name: 'Japanese',
      flag: toAbsoluteUrl('/media/flags/japan.svg'),
    },
    {
      lang: 'de',
      name: 'German',
      flag: toAbsoluteUrl('/media/flags/germany.svg'),
    },
    {
      lang: 'fr',
      name: 'French',
      flag: toAbsoluteUrl('/media/flags/france.svg'),
    },
  ]
  const lang = useLang()
  const intl = useIntl();

  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div className='d-flex justify-content-end' data-kt-booking-extra-table-toolbar='base'>
        {/* begin::Filter */}
       {/* <PaymentMethodListFilter />*/}
          {/* end::Filter */}

      {/* begin::Export */}
      {/*<button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        Export
      </button>*/}
      {/* end::Export */}

      {/* begin::Add user */}
      <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        {intl.formatMessage({ id: 'COMMON.ADD_OPTION' })}
        </button>
      {/* end::Add user */}
    </div>
  )
}

export {PaymentMethodListToolbar}
